<template>
  <div class="pdp-top">
    <slot name="breadcrumbs"></slot>

    <div class="container container--flush">
      <div class="product-block-list product-block-list--medium">
        <div class="product-block-list__wrapper">
          <div></div>
          <template v-if="hasImages">
            <ProductGallery :media="productData.product.media" :productTitle="selectedVariant.title" :key="componentKey"> </ProductGallery>
          </template>
          <template v-else>
            <img class="product-card__image placeholder" :src="placeholderImage" alt="Product Placeholder Image" />
          </template>

          <div class="product-block-list__item product-block-list__item--info">
            <div class="card" v-if="selectedVariant.variants">
              <div class="card__section">
                <div class="product-meta" v-if="selectedVariant.variants">
                  <template v-if="!productData.isConfigureOneTemplate && !hasRestrictWebSale">
                    <template v-if="productData.product.type == 'variant'">
                      <span v-if="childProducts.length > 0" class="product-meta__price" v-html="convertCurrency(selectedVariant.variants[0].price)"></span>
                      <span class="product-meta__compare-at-price" v-if="(currentPrice * 100).toFixed(0) < selectedVariant.variants[0].price && childProducts.length > 0" v-html="formatPrice(selectedVariant.variants[0].price)"></span>
                    </template>
                    <template v-else-if="productTemplate == 'sets'"> </template>
                    <template v-else-if="isSetsProductType"> </template>
                    <template v-else>
                      <span class="product-meta__price" v-html="convertCurrency(selectedVariant.variants[0].price)"></span>
                      <span class="product-meta__compare-at-price" v-if="(currentPrice * 100).toFixed(0) < selectedVariant.variants[0].price" v-html="formatPrice(selectedVariant.variants[0].price)"></span>
                    </template>
                  </template>

                  <div class="product-meta__reference">
                    <span class="product-meta__badge" :class="customBadgeColor" v-if="hasCustomBadge" v-html="customBadgeText"></span>

                    <template v-if="!productData.isConfigureOneTemplate">
                      <template v-if="productData.product.type == 'variant'">
                        <span v-if="selectedVariant.variants[0].sku && childProducts.length > 0" class="product-meta__sku" v-html="selectedVariant.variants[0].sku"></span>
                      </template>
                      <template v-else>
                        <span v-if="selectedVariant.variants[0].sku" class="product-meta__sku" v-html="selectedVariant.variants[0].sku"></span>
                      </template>

                      <span class="product-meta__stock-status available" v-if="hasRestrictWebSale"> </span>
                      <span class="product-meta__stock-status available" v-else-if="selectedVariant.available">
                        <Icon name="checkmark" size="16px"></Icon>
                        In Stock
                      </span>
                      <span class="product-meta__stock-status unavailable" v-else-if="hasRestrictWebSale"> </span>
                      <span class="product-meta__stock-status unavailable" v-else>
                        <Icon name="close" size="16px"></Icon>
                        Out Of Stock
                      </span>
                    </template>
                  </div>

                  <h1 class="product-meta__title" v-html="productData.product.title"></h1>

                  <div class="product-meta__prop-65-holder">
                    <a target="_blank" :href="productData.prop65Link || '#'" class="mobile-margins">
                      <Icon name="prop-65" size="16px"></Icon>
                      <span class="product-meta__prop-65">California Residents – Proposition 65</span>
                    </a>
                  </div>

                  <template v-if="productData.product.type == 'variant' && childProducts.length > 0">
                    <p class="product-meta__selected">Selected: <span v-html="selectedVariant.variants[0].name"></span></p>

                    <div class="product-meta__variant-box">
                      <template v-for="variant in childProducts">
                        <button :class="[selectedVariant === variant.products[0] ? 'active' : '']" class="product-meta__variant-card" @click="changeVariant(variant.products[0])" v-html="variant.products[0].variants[0].sku" :key="variant.products[0].variants[0].sku"></button>
                      </template>
                    </div>

                    <div class="select-wrapper select-wrapper--primary mobile-margins">
                      <Icon name="chevron-down" size="16px"></Icon>
                      <select @change="(value) => changeVariantDropdown(value)" :value="selectedVariant.variants[0].id">
                        <template v-for="variant in childProducts">
                          <option :value="variant.products[0].variants[0].id" @click="changeVariant(variant.products[0])" v-html="variant.products[0].variants[0].name" :key="variant.products[0].variants[0].sku"></option>
                        </template>
                      </select>
                    </div>
                  </template>
                  <template v-else-if="productData.product.type == 'master'"> </template>
                  <template v-else> </template>

                  <template v-if="isToolStorage">
                    <div class="notify-me-space">
                      <div v-if="JSON.parse(this.data).klaviyoToggle">
                        <h2>Subscribe for back in stock notifications</h2>
                        <div v-if="!JSON.parse(data).customer">
                          <div class="form__input-wrapper form__input-wrapper--labelled">
                            <input type="email" v-model="email" class="form__field form__field--text" required />
                            <label for="Subscribe email notification" class="form__floating-label">Your email</label>
                          </div>
                        </div>
                        <div id="errorMsg" style="margin-bottom: 10px"></div>
                        <button id="notify" class="button button--primary" primary @click="notifyMe(email, JSON.parse(data).product.variants[0].id)">NOTIFY ME</button>
                      </div>
                      <br />
                    </div>
                    <div class="product-meta__warning-box">
                      <p class="product-meta__warning-strong">This item is not available!</p>
                      <p class="product-meta__warning-content">
                        Please contact us for ordering information at
                        <br />
                        <a href="#">(800) MAC-TOOLS</a>
                      </p>
                    </div>
                  </template>

                  <template v-else-if="hasRestrictWebSale">
                    <div class="product-meta__warning-box">
                      <p class="product-meta__warning-strong">This item is not available for purchase online!</p>
                      <p class="product-meta__warning-content">
                        Please contact us for ordering information at
                        <br />
                        <a href="#">(800) MAC-TOOLS</a>
                      </p>
                    </div>
                  </template>

                  <template v-else-if="hasReplacement">
                    <button @click="addToCart(selectedVariant.variants[0].id)" disabled class="button button--primary disabled">Discontinued</button>
                  </template>

                  <template v-else-if="isStudent">
                    <template v-if="hasMTSchool">
                      <button @click="addToCart(selectedVariant.variants[0].id)" disabled class="button button--primary disabled">Not Available</button>
                    </template>

                    <template v-else-if="!isAvailable">
                      <div class="notify-me-space">
                        <div v-if="JSON.parse(this.data).klaviyoToggle">
                          <h2>Subscribe for back in stock notifications</h2>
                          <div v-if="!JSON.parse(data).customer">
                            <div class="form__input-wrapper form__input-wrapper--labelled">
                              <input type="email" v-model="email" class="form__field form__field--text" required />
                              <label for="Subscribe email notification" class="form__floating-label">Your email</label>
                            </div>
                          </div>
                          <div id="errorMsg" style="margin-bottom: 10px"></div>
                          <button id="notify" class="button button--primary" primary @click="notifyMe(email, JSON.parse(data).product.variants[0].id)">NOTIFY ME</button>
                        </div>
                        <br />
                      </div>

                      <div class="product-meta__warning-box">
                        <p class="product-meta__warning-strong">This item is not available!</p>
                        <p class="product-meta__warning-content">
                          Please contact us for ordering information at
                          <br />
                          <a href="#">(800) MAC-TOOLS</a>
                        </p>
                      </div>
                    </template>

                    <template v-else-if="discontinueEmpty">
                      <div class="product-form__holder mobile-margins">
                        <div v-if="!productData.isConfigureOneTemplate" class="product-form__info-item product-form__info-item--quantity">
                          <div class="product-form__info-content">
                            <div class="quantity-selector quantity-selector--product one" v-if="hasMinQtyAboveOne">
                              <button @click="[quantity > getMinQtyAboveOne() ? (quantity = parseInt(quantity) - getPackQtyAboveOne) : quantity]" type="button" class="quantity-selector__button" aria-label="Decrease quantity" title="Decrease quantity">
                                <Icon name="minus" size="16px"></Icon>
                              </button>
                              <input v-model="quantity" id="quantity-input" name="quantity" aria-label="Quantity" class="quantity-selector__value" inputmode="numeric" value="1" size="3" />
                              <button @click="quantity = parseInt(quantity) + getPackQtyAboveOne" type="button" class="quantity-selector__button" aria-label="Increase quantity" title="Increase quantity">
                                <Icon name="plus" size="16px"></Icon>
                              </button>
                            </div>
                            <div class="quantity-selector quantity-selector--product three" v-else>
                              <button @click="[quantity > 1 ? quantity-- : quantity]" type="button" class="quantity-selector__button" aria-label="Decrease quantity" title="Decrease quantity" :disabled="isStudent && !hasBeenPurchased">
                                <Icon name="minus" size="16px"></Icon>
                              </button>
                              <input v-model="quantity" id="quantity-input" name="quantity" aria-label="Quantity" class="quantity-selector__value" inputmode="numeric" value="1" size="3" :disabled="isStudent && !hasBeenPurchased" />
                              <button @click="quantity++" type="button" class="quantity-selector__button" aria-label="Increase quantity" title="Increase quantity" :disabled="isStudent && !hasBeenPurchased">
                                <Icon name="plus" size="16px"></Icon>
                              </button>
                            </div>
                          </div>
                          <label for="quantity-input" class="product-form__info-title" v-if="hasMinQtyAboveOne">Qty (Minimum {{ getMinQtyAboveOne() }} Qty required)</label>
                          <label for="quantity-input" class="product-form__info-title" v-else>Qty</label>
                        </div>
                        <button v-if="!productData.isConfigureOneTemplate && isQuickview && isSetsProductType" @click="addToCartSet(selectedVariant.variants[0].id)" class="button button--primary add-to-cart-main">Add to cart</button>
                        <button v-else-if="!productData.isConfigureOneTemplate" @click="addToCart(selectedVariant.variants[0].id)" class="button button--primary add-to-cart-main">Add to cart</button>
                        <a v-else :href="productData.configureOneCtaUrl" class="button button--primary">{{ productData.configureOneCtaText }}</a>
                      </div>
                    </template>
                    <template v-else-if="!discontinueEmpty">
                      <button @click="addToCart(selectedVariant.variants[0].id)" disabled class="button button--primary disabled">Discontinued</button>
                    </template>
                    <template v-else>
                      <button @click="addToCart(selectedVariant.variants[0].id)" disabled class="button button--primary disabled">Not Available</button>
                    </template>
                  </template>

                  <template v-else-if="isStudent && !studentCanBuy">
                    <button @click="addToCart(selectedVariant.variants[0].id)" disabled class="button button--primary disabled">Not Available</button>
                  </template>
                  <template v-else-if="hasBeenPurchased">
                    <div class="product-meta__warning-box">
                      <p class="product-meta__warning-strong">This item is not available for purchase online!</p>
                      <p class="product-meta__warning-content">
                        Please contact us for ordering information at
                        <br />
                        <a href="#">(800) MAC-TOOLS</a>
                      </p>
                    </div>
                  </template>
                  <template v-else-if="!hasSalesChannelFlag">
                    <div class="product-meta__warning-box">
                      <p class="product-meta__warning-strong">This item is not available for purchase online!</p>
                      <p class="product-meta__warning-content">
                        Please contact us for ordering information at
                        <br />
                        <a href="#">(800) MAC-TOOLS</a>
                      </p>
                    </div>
                  </template>

                  <template v-else>
                    <template v-if="!isAvailable">
                      <div class="notify-me-space">
                        <div v-if="JSON.parse(this.data).klaviyoToggle">
                          <div v-if="JSON.parse(data).customer"></div>
                          <h2>Subscribe for back in stock notifications</h2>
                          <div v-if="!JSON.parse(data).customer">
                            <div class="form__input-wrapper form__input-wrapper--labelled">
                              <input type="email" v-model="email" class="form__field form__field--text" required />
                              <label for="Subscribe email notification" class="form__floating-label">Your email</label>
                            </div>
                          </div>
                          <div id="errorMsg" style="margin-bottom: 10px"></div>
                          <button id="notify" class="button button--primary" primary @click="notifyMe(email, JSON.parse(data).product.variants[0].id)">NOTIFY ME</button>
                        </div>
                        <br />
                      </div>
                      <div class="product-meta__warning-box">
                        <p class="product-meta__warning-strong">This item is not available!</p>
                        <p class="product-meta__warning-content">
                          Please contact us for ordering information at
                          <br />
                          <a href="#">(800) MAC-TOOLS</a>
                        </p>
                      </div>
                    </template>

                    <template v-else>
                      <div class="product-form__holder mobile-margins" :style="[isSetsProductType ? { 'padding-bottom': '15px' } : '']">
                        <template v-if="!isSetsProductType">
                          <div v-if="!productData.isConfigureOneTemplate" class="product-form__info-item product-form__info-item--quantity">
                            <div class="product-form__info-content">
                              <div class="quantity-selector quantity-selector--product two" v-if="hasMinQtyAboveOne">
                                <button @click="[quantity > getMinQtyAboveOne() ? (quantity = parseInt(quantity) - getPackQtyAboveOne) : quantity]" type="button" class="quantity-selector__button" aria-label="Decrease quantity" title="Decrease quantity">
                                  <Icon name="minus" size="16px"></Icon>
                                </button>
                                <input v-model="quantity" id="quantity-input" name="quantity" aria-label="Quantity" class="quantity-selector__value" inputmode="numeric" value="1" size="3" />
                                <button @click="quantity = parseInt(quantity) + getPackQtyAboveOne" type="button" class="quantity-selector__button" aria-label="Increase quantity" title="Increase quantity">
                                  <Icon name="plus" size="16px"></Icon>
                                </button>
                              </div>
                              <div class="quantity-selector quantity-selector--product four" v-else>
                                <button @click="[quantity > 1 ? quantity-- : quantity]" type="button" class="quantity-selector__button" aria-label="Decrease quantity" title="Decrease quantity">
                                  <Icon name="minus" size="16px"></Icon>
                                </button>
                                <input v-model="quantity" id="quantity-input" name="quantity" aria-label="Quantity" class="quantity-selector__value" inputmode="numeric" value="1" size="3" />
                                <button @click="quantity++" type="button" class="quantity-selector__button" aria-label="Increase quantity" title="Increase quantity">
                                  <Icon name="plus" size="16px"></Icon>
                                </button>
                              </div>
                            </div>
                            <label for="quantity-input" class="product-form__info-title" v-if="hasMinQtyAboveOne">Qty (Minimum {{ getMinQtyAboveOne() }} Qty required)</label>
                            <label for="quantity-input" class="product-form__info-title" v-else>Qty</label>
                          </div>

                          <button v-if="productTemplate == 'sets'" class="button button--primary add-to-cart-main">Add to cart</button>
                          <button v-else-if="!productData.isConfigureOneTemplate" @click="addToCart(selectedVariant.variants[0].id)" class="button button--primary add-to-cart-main">Add to cart</button>
                          <a v-else :href="productData.configureOneCtaUrl" class="button button--primary">{{ productData.configureOneCtaText }}</a>
                          <a v-if="isQuickview" :href="`/products/${productData.product.handle}`" class="button button--primary">View Product</a>
                        </template>
                        <template v-else>
                          <button v-if="productTemplate == 'sets'" class="button button--primary add-to-cart-main">Add to cart</button>

                          <!-- <button v-else-if="!productData.isConfigureOneTemplate" @click="addToCart(selectedVariant.variants[0].id)" class="button button--primary add-to-cart-main" v-show="false">Add to cartsss</button> -->
                          <!-- <a v-else :href="productData.configureOneCtaUrl" class="button button--primary">{{ productData.configureOneCtaText }}</a> -->
                          <!-- <a v-if="isQuickview" :href="`/products/${productData.product.handle}`" class="button button--primary">View Sets</a> -->
                          <button v-if="isQuickview" @click="addToCartSet(selectedVariant.variants[0].id)" class="button button--primary add-to-cart-main">Add to cart</button>
                        </template>
                      </div>
                    </template>
                  </template>

                  <div class="product-meta__accordion-holder" v-if="descriptionData.contents">
                    <div class="product-meta__accordion-title" @click="descriptionAccordion = !descriptionAccordion" @keyup.enter="descriptionAccordion = !descriptionAccordion" tabindex="0">
                      Product Description
                      <Icon class="product-meta__accordion-button" v-show="!descriptionAccordion" name="plus" size="20px"> </Icon>
                      <Icon class="product-meta__accordion-button" v-show="descriptionAccordion" name="minus" size="20px"> </Icon>
                    </div>
                    <div :class="[descriptionAccordion ? 'active' : '']" class="product-meta__accordion-content" v-html="descriptionData.contents"></div>
                  </div>

                  <div class="product-meta__accordion-holder second" v-if="hasWarrantyInfo">
                    <div class="product-meta__accordion-title" @click="warrantyAccordion = !warrantyAccordion" @keyup.enter="warrantyAccordion = !warrantyAccordion" tabindex="0">
                      Warranty Info
                      <Icon class="product-meta__accordion-button" v-show="!warrantyAccordion" name="plus" size="20px"> </Icon>
                      <Icon class="product-meta__accordion-button" v-show="warrantyAccordion" name="minus" size="20px"> </Icon>
                    </div>
                    <div :class="[warrantyAccordion ? 'active' : '']" class="product-meta__accordion-content">
                      <div class="product-meta__warranty-holder" v-if="warrantyText != undefined">
                        <p class="product-meta__warranty-title">Warranty Code</p>
                        <p class="product-meta__warranty-content" v-html="warrantyText"></p>
                      </div>
                    </div>
                  </div>

                  <div class="product-meta__accordion-holder second" v-if="productData.ServiceInfo != null">
                    <div class="product-meta__accordion-title" @click="serviceAccordion = !serviceAccordion" @keyup.enter="serviceAccordion = !serviceAccordion" tabindex="0">
                      Service Info
                      <Icon class="product-meta__accordion-button" v-show="!serviceAccordion" name="plus" size="20px"> </Icon>
                      <Icon class="product-meta__accordion-button" v-show="serviceAccordion" name="minus" size="20px"> </Icon>
                    </div>
                    <div :class="[serviceAccordion ? 'active' : '']" class="product-meta__accordion-content" v-html="descriptionData.contents"></div>
                  </div>

                  <template v-if="productData.product.type == 'variant'">
                    <button
                      v-if="BVAGlobal.customerTags != null && childProducts.length > 0 && !hasRestrictWebSale"
                      type="button"
                      name="addToWishList"
                      id="addToWishList"
                      class="product-meta__wishlist-btn product-form__cart-submit"
                      @click="toggleWishlist(selectedVariant.id, selectedVariant.handle, selectedVariant.variants[0].id, selectedVariant.title)"
                    >
                      <template v-if="wishlistLoaderVisible">
                        <span id="wishListLoader">
                          <Icon name="checkmark" size="16px"></Icon>
                        </span>
                      </template>
                      <template v-else>
                        <span class="heart-empty">
                          <Icon name="heart-empty" size="16px"></Icon>
                        </span>
                        <span class="heart-full">
                          <Icon name="heart-full" size="16px"></Icon>
                        </span>
                      </template>
                      <span id="addToWishListText"> Add to Wishlist </span>
                    </button>
                  </template>
                  <template v-else>
                    <button
                      v-if="BVAGlobal.customerTags != null && !hasRestrictWebSale"
                      type="button"
                      name="addToWishList"
                      id="addToWishList"
                      class="product-meta__wishlist-btn product-form__cart-submit"
                      @click="toggleWishlist(selectedVariant.id, selectedVariant.handle, selectedVariant.variants[0].id, selectedVariant.title)"
                    >
                      <template v-if="wishlistLoaderVisible">
                        <span id="wishListLoader">
                          <Icon name="checkmark" size="16px"></Icon>
                        </span>
                      </template>
                      <template v-else>
                        <span class="heart-empty">
                          <Icon name="heart-empty" size="16px"></Icon>
                        </span>
                        <span class="heart-full">
                          <Icon name="heart-full" size="16px"></Icon>
                        </span>
                      </template>
                      <span id="addToWishListText"> Add to Wishlist </span>
                    </button>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Icon from 'scripts/components/basic/Icon.vue';
  import ProductGallery from 'scripts/components/product/ProductGallery.vue';

  /**
   * @namespace ProductTop
   * @desc This component serves as a wrapper for the PDP Before + After section.
   *     In the future, this component will integrate with modal and lightbox
   *     components to display images in a lightbox carousel, which is why its
   *     being passed props that aren't used at the moment (3/8/21).
   *     SCSS is written in the global stylesheet to avoid layout shift during render.
   */
  export default {
    name: 'ProductTop',
    components: {
      Icon,
      ProductGallery,
    },
    props: {
      data: {
        type: String,
        default: '',
      },
      isQuickview: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      async notifyMe(customer_email, product_variant_id) {
        if (customer_email == null) {
          customer_email = '';
        }
        const url = `${this.productData.endpoint}/klaviyo`;
        const item = {
          email: customer_email,
          variant: product_variant_id,
        };
        try {
          const response = await fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              token: this.productData.token,
              mode: 'no-cors',
            },
            body: JSON.stringify(item),
          });
          const data = await response.json();
          if (data.success == true) {
            $('#errorMsg').remove();
            $('#notify').html('Subscribed');
          } else {
            if (data.status == false) {
              $('#errorMsg').html(data.errMsg);
            } else {
              $('#errorMsg').html(data.msg);
            }
          }
        } catch (error) {
          console.error('Error:', error);
        }
      },
      getChildProducts(data) {
        let childProductIDs = this.descriptionData.childproducts.childproduct;
        for (let i = 0; i < childProductIDs.length; i++) {
          if (childProductIDs[i] !== '') {
            let fetchURL = '/search?type=product&q=variants.sku:' + childProductIDs[i] + '&view=sku';
            fetch(fetchURL)
              .then((response) => response.json())
              .then((prodData) => {
                if (prodData.products.length > 0) {
                  this.childProducts.push(prodData);
                }
              })
              .then(() => {
                this.selectedVariant = this.childProducts[0].products[0];
                this.quantity = this.getMinQtyAboveOne();
              })

              .then(() => this.checkWishlist());
          }
        }
      },
      changeVariant(newVariant) {
        this.selectedVariant = newVariant;
        this.BVAGlobal.currentVariant = newVariant;
        //console.log("changeVariant",this.selectedVariant);
      },
      changeVariantDropdown(newVariant) {
        let selectedValue = parseInt(newVariant.srcElement.value);
        for (let i = 0; i < this.childProducts.length; i++) {
          if (this.childProducts[i].products[0].variants[0].id === selectedValue) {
            this.selectedVariant = this.childProducts[i].products[0];
            this.BVAGlobal.currentVariant = this.childProducts[i].products[0];
            this.quantity = this.getMinQtyAboveOne();
            //console.log("productData.product.media",this.productData.product.media);
            //console.log("selectedVariant.media",this.selectedVariant.media);
            this.productData.product.media = this.selectedVariant.media;
            //console.log("changeVariantDropdown",this.selectedVariant);
            this.componentKey += 1;
          }
        }
      },
      addToCart(variantToAdd) {
        let scopedThis = this;
        let extraProperties = {};
        let packQtySuffix = 1;

        try {
          document.querySelector('.modal__close').click();
        } catch (e) {}

        extraProperties['SKU'] = this.selectedVariant.variants[0].sku;
        extraProperties['compare_price'] = this.selectedVariant.variants[0].compare_at_price;

        if (this.thresholdReached) {
          extraProperties['STP discount limit exceeded'] = 'Item added at regular price';
        }

        if (this.isStudent) {
          extraProperties['_stp_price'] = this.currentPrice;
          extraProperties['_amount_spent'] = parseFloat(this.BVAGlobal.customerSpent);
          extraProperties['_discount_limit'] = this.discountLimit;
        }

        for (let i = 0; i < this.selectedVariant.tags.length; i++) {
          if (this.selectedVariant.tags[i].includes('EP:UpsFreightOverride|')) {
            // split it and add it
            let freightSuffix = this.selectedVariant.tags[i].split('|');
            if (freightSuffix.includes('F')) {
              extraProperties['Shipped By'] = 'Freight';
            } else if (freightSuffix.includes('U')) {
              extraProperties['Shipped By'] = 'UPS';
            }
          }
          if (this.selectedVariant.tags[i].includes('EP:PackQty|')) {
            packQtySuffix = parseInt(this.selectedVariant.tags[i].split('|')[1]);
            if (packQtySuffix > 1) {
              extraProperties['_packSize'] = packQtySuffix;
            }
          }
        }

        fetch('/cart/add.js', {
          method: 'POST',
          body: JSON.stringify({
            id: variantToAdd,
            quantity: this.quantity,
            properties: extraProperties,
          }),
          headers: {
            'Content-Type': 'application/json',
          },
        }).then(function () {
          fetch('/cart.js')
            .then((response) => response.json())
            .then((cartData) => {
              //console.log(cartData);
              /*
            for(let i=0; i<cartData.items.length; i++){
              let item = cartData.items[i];
              item.packSize = 7;

            }
            */

              if (!localStorage.getItem('set_products')) {
                scopedThis.openMiniCart(cartData);
              }
              localStorage.removeItem('set_products');
            });
        });

        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
      },
      addToCartSet(variantToAdd) {
        let scopedThis = this;
        let extraProperties = {};
        let packQtySuffix = 1;
        try {
          document.querySelector('.modal__close').click();
        } catch (e) {}
        extraProperties['SKU'] = this.selectedVariant.variants[0].sku;
        extraProperties['compare_price'] = this.selectedVariant.variants[0].compare_at_price;
        if (this.thresholdReached) {
          extraProperties['STP discount limit exceeded'] = 'Item added at regular price';
        }
        if (this.isStudent) {
          extraProperties['_stp_price'] = this.currentPrice;
          extraProperties['_amount_spent'] = parseFloat(this.BVAGlobal.customerSpent);
          extraProperties['_discount_limit'] = this.discountLimit;
        }
        for (let i = 0; i < this.selectedVariant.tags.length; i++) {
          if (this.selectedVariant.tags[i].includes('EP:UpsFreightOverride|')) {
            // split it and add it
            let freightSuffix = this.selectedVariant.tags[i].split('|');
            if (freightSuffix.includes('F')) {
              extraProperties['Shipped By'] = 'Freight';
            } else if (freightSuffix.includes('U')) {
              extraProperties['Shipped By'] = 'UPS';
            }
          }
          if (this.selectedVariant.tags[i].includes('EP:PackQty|')) {
            packQtySuffix = parseInt(this.selectedVariant.tags[i].split('|')[1]);
            if (packQtySuffix > 1) {
              extraProperties['_packSize'] = packQtySuffix;
            }
          }
        }
        let newSetQuery = [
          {
            id: variantToAdd,
            quantity: this.quantity,
            properties: extraProperties,
          },
          ...this.setProductQuery,
        ];
        let chunks = 5;
        let setQuerySize = newSetQuery.length / chunks;
        if (newSetQuery.length % chunks >= 1) {
          setQuerySize = Math.ceil(setQuerySize);
        }
        function sliceIntoChunks(arr, chunkSize) {
          const res = [];
          for (let i = 0; i < arr.length; i += chunkSize) {
            const chunk = arr.slice(i, i + chunkSize);
            res.push(chunk);
          }
          return res;
        }
        let setChunks = sliceIntoChunks(newSetQuery, chunks);
        setChunks.forEach((element, i) => {
          setTimeout(function () {
            let formData = {
              items: element,
            };
            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(formData),
            })
              .then((response) => {
                if (++i == setQuerySize) {
                  fetch('/cart.js')
                    .then((response) => response.json())
                    .then((cartData) => scopedThis.openMiniCart(cartData));
                  window.scroll({ top: 0, left: 0, behavior: 'smooth' });
                }
              })
              .catch((error) => {
                console.error('Error:', error);
              });
          }, i * 4000);
        });
      },
      async addWishListItem(productID, handle, variantID, title) {
        this.showWishListLoader(true);
        const qty = this.quantity;
        const customerID = this.BVAGlobal.customerID;
        if (!customerID || customerID === 0 || !productID || productID === 0 || !handle || handle === 0 || !variantID || variantID === 0) {
          return;
        }

        const url = this.productData.endpoint + '/addWishListItem';
        const item = { customerId: customerID, productId: productID, handle: handle, variantId: variantID, qty: qty, title: title };

        try {
          let scopedThis = this;
          const response = await fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              token: this.productData.token,
              mode: 'no-cors',
            },
            body: JSON.stringify(item),
          });
          const data = await response.json();
          if (!data.result) {
            console.log(data.message);
          } else {
            document.getElementById('addToWishList').setAttribute('data-wishlist-id', data.data.wishListItemId);
            const wishListItem = data.data;
            this.getWishListItems();
          }
          scopedThis.showWishListLoader(false);
        } catch (error) {
          this.showWishListLoader(false);
        }
      },
      async removeWishListItem(productID, handle, variantID) {
        this.showWishListLoader(true);
        const qty = this.quantity;
        const customerID = this.BVAGlobal.customerID;
        const wishlistItemID = document.getElementById('addToWishList').getAttribute('data-wishlist-id');
        if (!customerID || customerID === 0) {
          return;
        }

        const url = this.productData.endpoint + '/removeWishListItem';
        const item = { customerId: customerID, wishListItemId: wishlistItemID };

        try {
          let scopedThis = this;
          const response = await fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              token: this.productData.token,
              mode: 'no-cors',
            },
            body: JSON.stringify(item),
          });
          const data = await response.json();
          if (!data.result) {
          } else {
            document.querySelector('#addToWishList').classList.remove('btn-disabled');
            scopedThis.showWishListLoader(false);
          }
        } catch (error) {
          this.showWishListLoader(false);
        }
      },
      toggleWishlist(productID, handle, variantID, title) {
        if (document.querySelector('#addToWishList').classList.contains('btn-disabled')) {
          this.removeWishListItem(productID, handle, variantID);
        } else {
          this.addWishListItem(productID, handle, variantID, title);
        }
      },
      showWishListLoader(show) {
        const loader = document.getElementById('wishListLoader');
        if (show) {
          this.wishlistLoaderVisible = true;
        } else {
          this.wishlistLoaderVisible = false;
        }
      },
      async getWishListItems() {
        const url = this.productData.endpoint + '/getWishListItems/' + this.BVAGlobal.customerID;
        try {
          const response = await fetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              token: this.productData.token,
            },
          });
          const data = await response.json();
          if (!data.result) {
            console.log(data.message);
          } else {
            this.wishListItems = data.data.filter((item) => parseInt(item.ProductID) == this.selectedVariant.id);
            this.updateAddToWishListCtrl();
          }
        } catch (error) {
          console.error('Error:', error);
        }
      },
      updateAddToWishListCtrl() {
        const hasOnlyDefaultVariant = this.selectedVariant.variants[0].title == 'Default Title';
        if (hasOnlyDefaultVariant) {
          this.updateWishListButtonByVariant(this.selectedVariant.variants[0].id);
        } else {
          // Disable controls for products with variants
        }
      },
      updateWishListButtonByVariant(id) {
        if (this.wishListItems.length > 0) {
          const found = this.wishListItems.find((itm) => itm.VariantID == id);
          this.disableAddToWishListButton(found != undefined);
        }
      },
      disableAddToWishListButton(disable) {
        const btn = document.getElementById('addToWishList');
        // btn.disabled = disable;
        btn.classList.add('btn-disabled');

        const btnText = document.getElementById('addToWishListText');
        btnText.innerHTML = disable ? 'Added to Wishlist' : 'Add to Wishlist';
      },
      async checkWishlist() {
        const url = this.productData.endpoint + '/getWishListItems/' + this.BVAGlobal.customerID;
        try {
          const response = await fetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              token: this.productData.token,
            },
          });
          const data = await response.json();
          if (!data.result) {
            console.log(data.message);
          } else {
            for (let i = 0; i < data.data.length; i++) {
              if (data.data[i].Handle == this.selectedVariant.handle) {
                document.getElementById('addToWishList').setAttribute('data-wishlist-id', data.data[i].WishListItemID);
                this.disableAddToWishListButton(true);
              }
            }
          }
        } catch (error) {
          console.error('Error:', error);
        }
      },
      convertCurrency(value) {
        if (this.BVAGlobal.customerID != 0) {
          let customerTags = this.BVAGlobal.customerTags.join(',');
          if (customerTags.includes('UserType:STPStudent')) {
            if (this.getPrice('PRICE:STP|') != false && !this.thresholdReached && this.studentCanBuy) {
              this.currentPrice = parseFloat(this.getPrice('PRICE:STP|'));
              return '$' + this.getPrice('PRICE:STP|');
            }
            this.currentPrice = value / 100;
            return (value / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
          }
          if (customerTags.includes('UserType:Punchout')) {
            if (this.getPrice('PRICE:PO|') != false) {
              this.currentPrice = parseFloat(this.getPrice('PRICE:PO|'));
              return '$' + this.getPrice('PRICE:PO|');
            }
            this.currentPrice = value / 100;
            return '$' + (value / 100).toFixed(2);
          }
          if (customerTags.includes('UserType:STPStaff')) {
            if (this.getPrice('PRICE:STP|') != false) {
              this.currentPrice = parseFloat(this.getPrice('PRICE:STP|'));
              return '$' + this.getPrice('PRICE:STP|');
            }
            this.currentPrice = value / 100;
            return (value / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
          }
          if (customerTags.includes('UserType:NationalPartner')) {
            if (this.getPrice('PRICE:NP|') != false) {
              this.currentPrice = parseFloat(this.getPrice('PRICE:NP|'));
              return '$' + this.getPrice('PRICE:NP|');
            }
            this.currentPrice = value / 100;
            return (value / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
          }
           if (customerTags.includes('UserType:Employee')) {
            if (this.getPrice('PRICE:EP|') != false) {
              this.currentPrice = parseFloat(this.getPrice('PRICE:EP|'));
              return '$' + this.getPrice('PRICE:EP|');
            }
            this.currentPrice = value / 100;
            return (value / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
          }
          if (customerTags.includes('UserType:Regular')) {
            this.currentPrice = value / 100;
            return (value / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
          }
        }
        this.currentPrice = value / 100;
        return (value / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
      },
      formatPrice(incomingPrice) {
        let priceValue = incomingPrice / 100;
        return priceValue.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
      },
      formatSpec(specString) {
        let specName = specString.split('|')[0];
        specName = specName.replace('MT_', '');
        specName = specName.replace('_Specs', '');
        specName = specName.replace('Warranty', '');
        return specName;
      },
      formatSpecValue(specString) {
        if (specString.includes('WarrantyCode')) {
          let tags = this.selectedVariant.tags.join(',');
          if (tags.includes('EP:WarrantyCode|')) {
            for (let i = 0; i < this.selectedVariant.tags.length; i++) {
              if (this.selectedVariant.tags[i].includes('EP:WarrantyCode|')) {
                if (this.selectedVariant.tags[i].split('|')[1]) {
                  return this.selectedVariant.tags[i].split('|')[1];
                }
              }
            }
          }
        }
        return specString.split('|')[1];
      },
      getPrice(priceType) {
        for (let i = 0; i < this.selectedVariant.tags.length; i++) {
          if (this.selectedVariant.tags[i].includes(priceType)) {
            return this.selectedVariant.tags[i].split(priceType)[1];
          }
        }
        return false;
      },
      discountLimitCheck() {
        if (this.BVAGlobal.customerTags != null && this.BVAGlobal.customerTags.includes('UserType:STPStudent')) {
          let customerTags = this.BVAGlobal.customerTags.join(',');
          if (customerTags.includes('discount_limit:')) {
            for (let i = 0; i < this.BVAGlobal.customerTags.length; i++) {
              if (this.BVAGlobal.customerTags[i].includes('discount_limit:')) {
                this.discountLimit = parseInt(this.BVAGlobal.customerTags[i].split(':')[1]);
              }
            }
          }
        }
      },
      openMiniCart(cartData) {
        this.productInCart = true;
        let cartContainer = document.querySelector('#mini-cart');
        let cartHTML = '';
        let totalSavings = 0;
        if (cartData.items.length > 0) {
          cartHTML += `
            <div class="mini-cart__inner">
              <div class="mini-cart__content">
                <div class="mini-cart__line-item-list">
          `;
          for (let i = 0; i < cartData.items.length; i++) {
            let lineItem = cartData.items[i];
            let priceHTML = '';
            let propertiesHTML = '';
            let comparePrice = 0;
            for (const [key, value] of Object.entries(lineItem.properties)) {
              if (key == 'compare_price') {
                comparePrice = value;
              } else if (key == 'Shipped By' || key == 'STP discount limit exceeded' || key == 'SKU') {
                propertiesHTML += `
                  <li class="mini-cart__property"><strong>${key}</strong>: ${value}</li>
                `;
              }
            }
            if (lineItem.price < comparePrice) {
              priceHTML = `
                <span class="price price--highlight">${this.formatPrice(lineItem.final_line_price)}</span>
                <span class="price price--compare">${this.formatPrice(comparePrice * lineItem.quantity)}</span>
              `;
              totalSavings += (comparePrice - lineItem.price) * lineItem.quantity;
            } else {
              priceHTML = `
                <span class="price price--highlight">${this.formatPrice(lineItem.final_line_price)}</span>
              `;
            }
            let imageHTML = '';
            if (lineItem.image) {
              imageHTML = `<img src="${lineItem.image}" alt="${lineItem.title}">`;
            } else {
              imageHTML = `<img src="${lineItem.image}" style='opacity: 0;' alt="${lineItem.title}">`;
            }
            let lineItemHTML = `
              <div class="mini-cart__line-item var_${lineItem.id}">
                <div class="mini-cart__image-wrapper">
                  <div class="aspect-ratio" style="padding-bottom: 100.0%">
                    ${imageHTML}
                  </div>
                </div>
                <div class="mini-cart__item-wrapper">
                  <div class="mini-cart__product-info">
                    <a href="/products/${lineItem.handle}?variant=${lineItem.id}" class="mini-cart__product-title text--strong link">${lineItem.title}</a>
                    <ul class="mini-cart__property-list" role="list">
                      ${propertiesHTML}
                    </ul>
                    <div class="mini-cart__price-list">
                      ${priceHTML}
                    </div>
                  </div>
                  <div class="mini-cart__quantity">
                    <div class="quantity-selector">
                      <button class="quantity-selector__button" data-action="decrease-quantity" data-quantity="${lineItem.quantity - 1}" data-line="${i + 1}" aria-label="Decrease quantity" title="Decrease quantity">
                        <svg focusable="false" class="icon icon--minus" viewBox="0 0 10 2" role="graphics-symbol">
                          <path d="M10 0v2H0V0z" fill="currentColor"></path>
                        </svg>
                      </button>
                      <input aria-label="Quantity" class="quantity-selector__value" inputmode="numeric" data-current-value="${lineItem.quantity}" data-line="${i + 1}" value="${lineItem.quantity}" size="2">
                      <button class="quantity-selector__button" data-action="increase-quantity" data-quantity="${lineItem.quantity + 1}" data-line="${i + 1}" aria-label="Increase quantity" title="Increase quantity">
                        <svg focusable="false" class="icon icon--plus" viewBox="0 0 10 10" role="graphics-symbol">
                          <path d="M6 4h4v2H6v4H4V6H0V4h4V0h2v4z" fill="currentColor" fill-rule="evenodd"></path>
                        </svg>
                      </button>
                    </div>
                    <a href="/cart/change?quantity=0&amp;line=1" data-action="decrease-quantity" data-quantity="0" data-line="${i + 1}" class="mini-cart__quantity-remove link">Remove</a>
                  </div>
                </div>
              </div>
            `;
            cartHTML += lineItemHTML;
          }

          let savingsHTML = '';
          if (totalSavings > 0) {
            savingsHTML = `<span class="mini-cart__amount-saved">You saved <span>${this.formatPrice(totalSavings)}</span>!</span>`;
          }
          cartHTML += `
                </div>
                <div class="mini-cart__recap">
                  <div class="mini-cart__recap-price-line">
                    <span>Total</span>
                    <span>&nbsp;${this.formatPrice(cartData.total_price)}</span>
                  </div>
                  ${savingsHTML}
                  <div class="mini-cart__button-container">
                    <div class="button-group button-group--loose button-group--fit">
                      <a href="/cart" class="button button--secondary">View cart</a>
                      <button type="submit" name="checkout" class="button button--primary">Checkout</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          `;
        } else {
          cartHTML = `
            <div class="mini-cart__content mini-cart__content--empty">
              <div class="mini-cart__empty-state">
                <svg focusable="false" width="81" height="70" viewBox="0 0 81 70">
                  <g transform="translate(0 2)" stroke-width="4" stroke="#1e2d7d" fill="none" fill-rule="evenodd">
                    <circle stroke-linecap="square" cx="34" cy="60" r="6"></circle>
                    <circle stroke-linecap="square" cx="67" cy="60" r="6"></circle>
                    <path d="M22.9360352 15h54.8070373l-4.3391876 30H30.3387146L19.6676025 0H.99560547"></path>
                  </g>
                </svg>
                <p class="heading h4">Your cart is empty</p>
              </div>
              <a href="/collections/all" class="button button--primary button--full">Shop our products</a>
            </div>
          `;
        }

        //cartContainer.innerHTML = cartHTML;
        //document.querySelector('.header__cart-count').innerHTML = cartData.item_count;

        //document.querySelector('.header__cart-toggle').click();

        setTimeout(function () {
          document.documentElement.dispatchEvent(
            new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                quantity: 1,
              },
            }),
          );
        }, 500);
      },
      cartCheck() {
        fetch('/cart.js')
          .then((response) => response.json())
          .then((cartData) => {
            for (let i = 0; i < cartData.items.length; i++) {
              if (cartData.items[i].id == this.selectedVariant.variants[0].id) {
                if (!this.hasBeenPurchased) {
                  this.productInCart = true;
                }
              }
            }
          });
      },
      getMinQtyAboveOne() {
        let tags = this.selectedVariant.tags.join(',');

        if (tags.includes('EP:MinimumQty|')) {
          for (let i = 0; i < this.selectedVariant.tags.length; i++) {
            if (this.selectedVariant.tags[i].includes('EP:MinimumQty|')) {
              let qtySuffix = parseInt(this.selectedVariant.tags[i].split('|')[1]);
              if (qtySuffix > 1) {
                return qtySuffix;
              }
            }
          }
        }
        return 1;
      },
      getChildProductsSet(childProductsHandles) {
        let count = 0;
        childProductsHandles.forEach((handle, index) => {
          if (handle !== '') {
            let fetchURL = '/search?type=product&q=variants.sku:' + handle + '&view=sku';
            fetch(fetchURL)
              .then((response) => response.json())
              .then((prodData) => {
                if (prodData.products.length > 0) {
                  this.allChildProducts.push(prodData);
                  //console.log("index",index, prodData);
                  this.quantities[count] = this.getMinQtyAboveOneCountSet(prodData.products[0].tags);
                  this.packSize[count] = this.getPackQtyAboveOneCountSet(prodData.products[0].tags);
                  console.log('prodData', prodData);
                  if (prodData.products[0].available) {
                    this.setProductQuery.push({
                      id: prodData.products[0].variants[0].id,
                      quantity: this.quantities[count],
                    });
                  }
                  count++;
                }
              });
          }
        });
      },
      getMinQtyAboveOneCountSet(childProductTags) {
        let tags = childProductTags.join(',');
        if (tags.includes('EP:MinimumQty|')) {
          for (let i = 0; i < childProductTags.length; i++) {
            if (childProductTags[i].includes('EP:MinimumQty|')) {
              let qtySuffix = parseInt(childProductTags[i].split('|')[1]);
              if (qtySuffix > 1) {
                return qtySuffix;
              }
            }
          }
        }
        return 1;
      },
      getPackQtyAboveOneCountSet(childProductTags) {
        let tags = childProductTags.join(',');
        if (tags.includes('EP:PackQty|')) {
          for (let i = 0; i < childProductTags.length; i++) {
            if (childProductTags[i].includes('EP:PackQty|')) {
              let packQtySuffix = parseInt(childProductTags[i].split('|')[1]);
              if (packQtySuffix > 1) {
                return packQtySuffix;
              }
            }
          }
        }
        return 1;
      },
    },

    computed: {
      isToolStorage() {
        let collectionTitleArray = [
          'Utility Carts',
          'Workbenches and Cabinets',
          'Tech™ Workstations',
          'Tech™ Top Attachments',
          'Tech™ Side Attachments',
          'Tech™ Work Surfaces',
          'Edge™ Workstations',
          'Edge™ Top Attachments',
          'Edge™ Work Surfaces',
          'Utility Cart Attachments and Accessories',
          'Macsimizer® HD Workstations',
          'Macsimizer® HD Top Attachments',
          'Macsimizer® HD Side Attachments',
          'Macsimizer® HD Work Surfaces',
          'Macsimizer® Workstations',
          'Macsimizer® Top Attachments',
          'Macsimizer® Side Attachments',
          'Macsimizer® Work Surfaces',
        ];
        let tags = '';
        if (this.productData.productCollections != undefined) {
          tags = this.productData.productCollections.join(',');
          for (let i = 0; i < this.productData.productCollections.length; i++) {
            for (let j = 0; j < collectionTitleArray.length; j++) {
              if (this.productData.productCollections[i].title == collectionTitleArray[j]) {
                return true;
              }
            }
          }
        }
        return false;
      },
      hasWarrantyInfo() {
        let tags = this.selectedVariant.tags.join(',');
        if (tags.includes('EP:WarrantyCode|')) {
          for (let i = 0; i < this.selectedVariant.tags.length; i++) {
            if (this.selectedVariant.tags[i].includes('EP:WarrantyCode|')) {
              if (this.selectedVariant.tags[i].split('|')[1]) {
                return true;
              }
            }
          }
        }
        return false;
      },
      warrantyText() {
        for (let i = 0; i < this.selectedVariant.tags.length; i++) {
          if (this.selectedVariant.tags[i].includes('EP:WarrantyCode|')) {
            if (this.selectedVariant.tags[i].split('|')[1]) {
              return this.selectedVariant.tags[i].split('|')[1];
            }
          }
        }
      },
      hasReplacement() {
        let tags = this.selectedVariant.tags.join(',');
        if (tags.includes('EP:ReplacementItemNum|') || tags.includes('EP:DiscontinueCode|D')) {
          for (let i = 0; i < this.selectedVariant.tags.length; i++) {
            if (this.selectedVariant.tags[i].includes('EP:ReplacementItemNum|')) {
              if (this.selectedVariant.tags[i].split('|')[1]) {
                return false;
              }
              return false;
            }
          }
          return false;
        }
        return false;
      },
      hasCustomBadge() {
        let tags = this.selectedVariant.tags.join(',');
        if (tags.includes('badge::')) {
          return true;
        }
        return false;
      },
      customBadgeColor() {
        let tags = this.selectedVariant.tags.join(',');
        if (tags.includes('badge::new')) {
          return 'new';
        }
        if (tags.includes('badge::sale')) {
          return 'sale';
        }
        return 'custom';
      },
      customBadgeText() {
        for (let i = 0; i < this.selectedVariant.tags.length; i++) {
          if (this.selectedVariant.tags[i].includes('badge::')) {
            return this.selectedVariant.tags[i].split('::')[1];
          }
        }
        return '';
      },
      hasMTSchool() {
        if (this.BVAGlobal.customerID != 0) {
          let customerTags = this.BVAGlobal.customerTags.join(',');
          let productSchools = [];
          for (let i = 0; i < this.selectedVariant.tags.length; i++) {
            let splitTag = this.selectedVariant.tags[i].split('|');
            if (splitTag[0] == 'schoolnames') {
              productSchools.push(splitTag[1]);
            }
          }
          if (customerTags.includes('UserType:STPStudent') && productSchools.includes(this.BVAGlobal.customerSchool)) {
            return false;
          }
        }
        return false;
      },
      hasBeenPurchased() {
        if (this.BVAGlobal.customerID != 0) {
          let customerTags = this.BVAGlobal.customerTags.join(',');
          let tags = this.selectedVariant.tags.join(',');
          if (customerTags.includes('UserType:STPStudent') && customerTags.includes(this.selectedVariant.variants[0].sku)) {
            return true;
          }
        }
        return false;
      },
      studentCanBuy() {
        if (this.BVAGlobal.customerTags != null && this.BVAGlobal.customerTags.includes('UserType:STPStudent')) {
          let variantTags = this.selectedVariant.tags.join(',');
          if (variantTags.includes('EP:StudentCanBuy|Y')) {
            return true;
          }
        }
        return false;
      },
      isStudent() {
        if (this.BVAGlobal.customerTags != null && this.BVAGlobal.customerTags.includes('UserType:STPStudent')) {
          return true;
        }
        return false;
      },
      isAvailable() {
        return this.selectedVariant.available;
      },
      hasSalesChannelFlag() {
        let tags = this.selectedVariant.tags.join(',');
        if (!tags.includes('EP:WebSalesChannelFlag|true')) {
          return false;
        }
        return true;
      },
      hasRestrictWebSale() {
        let tags = this.selectedVariant.tags.join(',');
        if (tags.includes('Restrict_web_sale') || tags.includes('restrict_web_sale')) {
          return true;
        }
        return false;
      },
      hasMinQtyAboveOne() {
        let tags = this.selectedVariant.tags.join(',');
        if (tags.includes('EP:MinimumQty|')) {
          for (let i = 0; i < this.selectedVariant.tags.length; i++) {
            if (this.selectedVariant.tags[i].includes('EP:MinimumQty|')) {
              let qtySuffix = parseInt(this.selectedVariant.tags[i].split('|')[1]);
              if (qtySuffix > 1) {
                return true;
              }
            }
          }
        }
        return false;
      },
      getPackQtyAboveOne() {
        let tags = this.selectedVariant.tags.join(',');
        if (tags.includes('EP:PackQty|')) {
          for (let i = 0; i < this.selectedVariant.tags.length; i++) {
            if (this.selectedVariant.tags[i].includes('EP:PackQty|')) {
              let packQtySuffix = parseInt(this.selectedVariant.tags[i].split('|')[1]);
              if (packQtySuffix > 1) {
                return packQtySuffix;
              }
            }
          }
        }
        return 1;
      },
      discontinueEmpty() {
        let tags = this.selectedVariant.tags.join(',');
        if (tags.includes('EP:DiscontinueCode|')) {
          for (let i = 0; i < this.selectedVariant.tags.length; i++) {
            if (this.selectedVariant.tags[i].includes('EP:DiscontinueCode|')) {
              let discSuffix = this.selectedVariant.tags[i].split('|')[1];
              if (discSuffix) {
                return false;
              }
            }
          }
        }
        return true;
      },
      hasImages() {
        return this.productData.product && this.productData.product.media && this.productData.product.media.length > 0;
      },
      thresholdReached() {
        if (this.BVAGlobal.customerTags != null && this.BVAGlobal.customerTags.includes('UserType:STPStudent')) {
          if (this.BVAGlobal.customerSpent > this.discountLimit) {
            return true;
          }
        }
        return false;
      },
      isSetsProductType() {
        return this.productData.product.type == 'sets';
      },
    },
    data() {
      return {
        productData: {},
        childProducts: [],
        productTemplate: {},
        selectedVariant: {},
        quantity: 1,
        descriptionAccordion: false,
        warrantyAccordion: false,
        serviceAccordion: false,
        placeholderImage: null,
        wishlistLoaderVisible: false,
        descriptionData: null,
        schoolStatus: null,
        discountLimit: null,
        wishListItems: [],
        currentPrice: 0,
        warrantyInfo: [],
        productInCart: false,
        BVAGlobal: window.__BVA__,
        packSize: 5,
        allChildProducts: [],
        quantities: [],
        packSize: [],
        setProductQuery: [],
        componentKey: 0,
        email: JSON.parse(this.data).customer,
      };
    },
    mounted() {
      this.$nextTick(() => {
        this.productData = JSON.parse(this.data);
        this.productTemplate = this.productData.productTemplate;
        this.selectedVariant = this.productData.product;
        this.descriptionData = JSON.parse(this.productData.product.description);
        this.discountLimitCheck();
        if (this.productData.product.type === 'variant') {
          this.getChildProducts(this.productData);
        } else {
          this.checkWishlist();
        }
        this.cartCheck();
        if (this.productData.placeholderImage) {
          this.placeholderImage = this.productData.placeholderImage;
        } else {
          this.placeholderImage = this.BVAGlobal.placeholderImage;
        }
        this.quantity = this.getMinQtyAboveOne();
        if (this.productData.product.type === 'sets' && this.productData.productSet !== null && this.productData.productSet !== undefined) {
          let setArray = this.productData.productSet.split(',');
          let childProductsHandles = setArray;
          this.getChildProductsSet(childProductsHandles);
        }
      });
    },
  };
</script>

<style lang="scss" scoped>
  .notify-me-space {
    margin-top: 24px;
  }

  .notify-me-button {
    background-color: rgb(255, 219, 10);
    color: rgb(0, 0, 0);
  }
</style>
